import React from "react";
import { Form, Input, Select, Row, Col, Card } from "antd";

const { Option } = Select;

const Header = ({ data, setData }) => {
    const isBC27 = data.kodeDokumen === "27";

    return (
        <Form layout="vertical">
            <Row gutter={24}>
                <Col span={isBC27 ? 12 : 8}>
                    <Card title={isBC27 ? "Pengajuan Asal" : "Pengajuan"} bordered={false} className="card-custom">
                        <Form.Item label="Nomor Aju">
                            <Input value={data.nomorAju} disabled />
                        </Form.Item>
                        {isBC27 && (
                            <>
                                <Form.Item label="Kantor Pabean Asal">
                                    <Select placeholder="Pilih Kantor Pabean Asal">
                                        <Option value="KPU_TP">KPU TANJUNG PRIOK</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item label="Jenis TPB Asal">
                                    <Select placeholder="Pilih Jenis TPB Asal">
                                        <Option value="PLB">PUSAT LOGISTIK BERIKAT</Option>
                                    </Select>
                                </Form.Item>
                            </>
                        )}
                    </Card>
                </Col>
                <Col span={isBC27 ? 12 : 8}>
                    <Card title={isBC27 ? "Pengajuan Tujuan" : "Kantor Pabean"} bordered={false} className="card-custom">
                        {isBC27 ? (
                            <>
                                <Form.Item label="Kantor Pabean Tujuan">
                                    <Select placeholder="Pilih Kantor Pabean Tujuan">
                                        <Option value="KPU_TP">KPU TANJUNG PRIOK</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item label="Jenis TPB Tujuan">
                                    <Select placeholder="Pilih Jenis TPB Tujuan">
                                        <Option value="KB">KAWASAN BERIKAT</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item label="Tujuan Pengiriman">
                                    <Select placeholder="Pilih Tujuan Pengiriman">
                                        <Option value="LAINNYA">LAINNYA</Option>
                                    </Select>
                                </Form.Item>
                            </>
                        ) : (
                            <>
                                <Form.Item label="Pelabuhan Bongkar">
                                    <Select placeholder="Pilih Pelabuhan Bongkar">
                                        <Option value="IDTPP">IDTPP - TANJUNG PRIOK</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item label="Kantor Pabean Bongkar">
                                    <Input disabled placeholder="Kantor Pabean Bongkar" />
                                </Form.Item>
                                <Form.Item label="Kantor Pengawas">
                                    <Select placeholder="Pilih Kantor Pengawas">
                                        <Option value="040300">040300 - KPU TANJUNG PRIOK</Option>
                                    </Select>
                                </Form.Item>
                            </>
                        )}
                    </Card>
                </Col>
                {!isBC27 && (
                    <Col span={8}>
                        <Card title="Keterangan Lain" bordered={false} className="card-custom">
                            <Form.Item label="Kode Gudang PLB">
                                <Input placeholder="Kode Gudang PLB" />
                            </Form.Item>
                        </Card>
                    </Col>
                )}
            </Row>
        </Form>
    );
};

export default Header;
